import React from 'react';

const NoticeCard = ({ title, description }) => {
  return (
    <div className="notice-card">
      <div className="notice-card__content">
        <h3 className="notice-card__title">{title}</h3>
        <p className="notice-card__description">{description}</p>
      </div>
    </div>
  );
};
export default NoticeCard;
